import React from 'react';
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from 'react-circular-progressbar'
import 'react-circular-progressbar/dist/styles.css'
import './style.scss'
import {
  COLOR_BLUE,
  COLOR_DARK_GREY,
  COLOR_GREEN,
  COLOR_RED,
  COLOR_YELLOW,
} from "../../constants/colors"

const CircularProgressBar = ({
                               active,
                               children,
                               percent,
                             }) => {
  const getRgbaByPercent = () => {
    if (percent || percent === 0) {
      if (percent > 50) {
        return COLOR_GREEN;
      }
      return percent > 25 ? COLOR_YELLOW : COLOR_RED;
    }
    return active ? COLOR_BLUE : false;
  };

  const getValue = () => {
    if (percent || percent === 0) {
      return percent
    }
    return active ? 100 : 0;
  };

  return (
    <CircularProgressbarWithChildren
      strokeWidth={10}
      value={getValue()}
      styles={buildStyles({
        rotation: 0.5,
        pathTransitionDuration: 0.5,
        pathColor: getRgbaByPercent(percent),
        trailColor: COLOR_DARK_GREY,
      })}
    >
      {children}
    </CircularProgressbarWithChildren>

  );
};

export default CircularProgressBar;